
function pickAttr(gl, shaderSet, name) {
	shaderSet.attrs[name] = gl.getAttribLocation(shaderSet.program, name);
}

function pickUniform(gl, shaderSet, name) {
	shaderSet.attrs[name] = gl.getUniformLocation(shaderSet.program, name);
}

export { pickAttr, pickUniform } ;